import {connect} from "react-redux";
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {
    CAlert,
    CButton,
    CCol,
    CForm,
    CFormInput,
    CInputGroup,
    CInputGroupText
} from "@coreui/react";
import {AgGridReact} from "ag-grid-react";
import {Loading} from "../../../components/common";

import * as productMethod from "../../../api/method/productMethod";
import * as posMethod from "../../../api/method/posMethod";
import * as o2Api from "../../../api/api";
import {getCkProductMappingBySourceCd} from "../../../api/api";

const ProductBarcode = (props) => {
    const gridRef = useRef();
    const containerStyle = useMemo(() => ({width: '100%', height: '100%'}), []);
    const gridStyle = useMemo(() => ({height: 500, width: '100%'}), []);

    const [loading, setLoading] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [error, setError] = useState({
        visible: false,
        message: ""
    });
    const [barcode, setBarcode] = useState("");

    const [columnDefs] = useState([
        {
            field: "seq",
            headerName: "No",
            width: 120,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            showDisabledCheckboxes: true
        },
        {field: 'restProductCd', headerName: '상품코드', width: 140},
        {field: 'productNm', headerName: '상품명'},
        {field: 'sourceCd', headerName: '바코드', width: 200}
    ])

    useEffect(() => {
        search();
    }, [])

    const search = () => {
        const {cmpCd, brandCd, productCd} = props.data;
        try {
            const params = {
                cmpCd: cmpCd,
                brandCd: brandCd,
                productCd: productCd
            };

            productMethod.getProductMappingList(params).then((result) => {
                setRowData(result);
            })
        } catch (e) {
            console.error(e.message);
        }
    };

    const deleteProductMapping = () => {
        const { api } = gridRef.current;
        if (api === null) return;

        const selectRows = api.getSelectedRows();
        if (selectRows.length > 0) {
            if (confirm("선택하신 바코드 정보를 삭제하시겠습니까?")) {
                // 데이터 변경
                selectRows[0].useYn = "N";
                delete selectRows[0].instTime;
                delete selectRows[0].updTime;

                try {
                    o2Api.putProductMapping(selectRows[0]).then((result) => {
                        const { responseBody, responseCode, responseMessage } = result.data;
                        if (responseCode === "200") {
                            // 성공
                            alert("정상적으로 처리되었습니다.");
                            search();
                        }
                        else {
                            setError({visible: true, message: "처리오류, 관리자에게 문의하세요."})
                        }
                        setBarcode("");
                    });
                } catch (e) {
                    console.error(e.message);
                    setError({visible: true, message: e.message})
                }
            }
        } else {

        }
    }

    const add = () => {
        if (barcode.length === 0) {
            return;
        }

        const {cmpCd, brandCd, productCd, restProductCd} = props.data;
        if (confirm("추가하시겠습니까?")) {
            // 중복체크
            const params = {
                cmpCd: cmpCd,
                brandCd: brandCd,
                productCd: productCd,
                restProductCd: restProductCd,
                sourceCd: barcode.trim()
            };
            console.log("중복체크 >>> params :: ", params);

            getCkProductMappingBySourceCd(params).then((result) => {
                const {responseBody, responseCode, responseMessage} = result.data;
                if (responseCode === "200") {
                    if (responseBody !== null) {
                        alert("해당 바코드는 이미 사용중입니다. 상품 정리 후 재등록 해 주시기 바랍니다." +
                            "\n상품코드 : " + responseBody.restProductCd + "  상품명 : " + responseBody.productNm);
                    }
                    else {
                        productMethod.putProductMapping(params).then((result) => {
                            if (Object.keys(result).length > 0) {
                                alert("정상 처리되었습니다.")
                                search();
                            }
                            else {
                                setError({visible: true, message: "등록오류, 관리자에게 문의하세요."})
                            }
                            setBarcode("");
                        });
                    }
                }
            })
        }
    }

    return (
        <div style={containerStyle}>
            {loading ? <Loading/> : null}
            {error.visible ? <CAlert color="danger">{error.message}</CAlert> : null}
            <CForm className={"row g-1"}>
                <CCol md={6}>
                    <CInputGroup className={"mb-1"}>
                        <CInputGroupText style={{width: 100}}>바코드</CInputGroupText>
                        <CFormInput id="barcode"
                                    style={{width: 200}}
                                    onChange={(e) => {
                                        setBarcode(e.target.value);
                                    }}
                        />
                        <CButton onClick={() => {
                            add();
                        }}>추가</CButton>
                    </CInputGroup>
                </CCol>
            </CForm>
            <div style={{height: 10}} />
            <div className="d-grid gap-1 d-md-flex justify-content-between" style={{marginBottom: 10}}>
                <h5>[{props.data.restProductCd}] {props.data.productNm}</h5>
                <div>
                    <CButton color="dark" onClick={deleteProductMapping}>삭제</CButton>
                </div>
            </div>
            <div className="ag-theme-alpine" style={gridStyle}>
                <AgGridReact
                    ref={gridRef}
                    rowSelection={'multiple'}
                    suppressDragLeaveHidesColumns={true}
                    rowData={rowData}
                    columnDefs={columnDefs}>
                </AgGridReact>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    const {account, store, selected} = state;
    return {
        account, store, selected
    };
};

export default connect(mapStateToProps, null)(ProductBarcode);
